/**
 * Author: Jose Torres 
 * jose.torres@simplestream.com 
 */

function remove(img) {
    img.parentNode && img.parentNode.removeChild(img);
}

export function fireTrackingPixel(url) {
    const img = new Image();
    img.style.height = '1px';
    img.style.width = '1px';
    img.style.display = 'none';

    const replyPromise = new Promise((resolve) => {
        img.onload = () => {
            remove(img);
            resolve('loaded');
        };
        img.onerror = () => {
            remove(img);
            resolve('...errored - but request likely sent');
        };
        img.src = url;
        document.body.appendChild(img);
    });

    return Promise.race([
        replyPromise,
        new Promise((_, reject) =>
            setTimeout(() => {
                remove(img);
                reject('...Tracking pixel timeout');
            }, 2000)
        )
    ]);
}
